const TableRowSkeleton = () => (
  <tr className="w-full border-b border-gray-100 last-of-type:border-none">
    <td className="whitespace-nowrap px-6 py-3">
      <div className="h-6 w-32 rounded bg-gray-200"></div>
    </td>
    <td className="px-6 py-3">
      <div className="h-6 w-48 rounded bg-gray-200"></div>
    </td>
    <td className="px-6 py-3">
      <div className="h-6 w-20 rounded bg-gray-200"></div>
    </td>
    <td className="px-6 py-3">
      <div className="h-6 w-20 rounded bg-gray-200"></div>
    </td>
    <td className="px-6 py-3">
      <div className="h-6 w-20 rounded bg-gray-200"></div>
    </td>
    <td className="whitespace-nowrap px-6 py-3">
      <div className="flex items-center justify-start gap-2">
        <div className="h-8 w-8 rounded-full bg-gray-200"></div>
        <div className="h-8 w-8 rounded-full bg-gray-200"></div>
      </div>
    </td>
  </tr>
);

const MobileCardSkeleton = () => (
  <div className="mb-2 w-full rounded-md bg-white p-4">
    <div className="mb-4 h-6 w-32 rounded bg-gray-200"></div>
    <div className="mb-2 h-5 w-40 rounded bg-gray-200"></div>
    <div className="mb-2 h-5 w-32 rounded bg-gray-200"></div>
    <div className="mb-4 h-5 w-24 rounded bg-gray-200"></div>
    <div className="flex items-center justify-center gap-2">
      <div className="h-8 w-8 rounded-full bg-gray-200"></div>
      <div className="h-8 w-8 rounded-full bg-gray-200"></div>
    </div>
  </div>
);

export default function GreetingMembershipsSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="lg:hidden">
        <MobileCardSkeleton />
        <MobileCardSkeleton />
        <MobileCardSkeleton />
      </div>

      <table className="hidden min-w-full text-left text-gray-900 lg:table">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3">Description</th>
            <th className="px-6 py-3">Price</th>
            <th className="px-6 py-3">Duration</th>
            <th className="px-6 py-3">EGreets</th>
            <th className="px-6 py-3">Active</th>
            <th className="px-6 py-3">Edit</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
        </tbody>
      </table>
    </div>
  );
}
